import request from './request'

const serviceApi = {
  saveService (data) {
    return request.post('/service', data)
  },
  listService (params) {
    return request.get('/services', { params })
  },
  updateService (serviceId, data) {
    return request.put('/services/' + serviceId, data)
  },
  deleteService (serviceId) {
    return request.delete('/services/' + serviceId)
  },
  getService (serviceId) {
    return request.get('/services/' + serviceId)
  },
}

export default serviceApi
